enum NameEnum {
    PASSWORD_SET = "PasswordSet",
    OTP = "Otp",
    ERROR = "Error",
    PHONE = "Phone",
    VERIFY_PHONE = "VerifyPhone",
    RESULT = "Result"
}

export default NameEnum;
